module.exports = __webpack_public_path__ + "static/media/splash4.1e620240.jpg";